// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html[data-v-325d5495]{overflow-x:hidden;overflow-y:auto}.margin[data-v-325d5495]{margin-top:141px}@media only screen and (max-width:960px){.margin[data-v-325d5495]{margin-top:80px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
